import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    container: {
        maxWidth: "100%",
        width: 400
    },
    formContainer: {
        width: "100%"
    }
});

export default stylesheet;
